<template>
  <div id="wangEditorMain" class="wangEditorMain"></div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { Message } from "element-ui";
import E from "wangeditor";
export default {
  name: "Editor",
  props: {
    /* 编辑器的内容 */
    value: {
      type: String,
      default: "",
    },
    /* 高度 */
    height: {
      type: Number,
      default: null,
    },
    /* 最小高度 */
    minHeight: {
      type: Number,
      default: null,
    },
    /* 只读 */
    readOnly: {
      type: Boolean,
      default: false,
    },
    /* 上传地址 */
    uploadUrl: {
      type: String,
      default: "",
    },
    //业务中我们经常会有添加操作和编辑操作，添加操作时，我们需清除上一操作留下的缓存
    isClear: {
      type: Boolean,
      default: false,
    },
    desc: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editorData: "",
      editor: null,
    };
  },
  computed: {
    // styles() {
    //   let style = {};
    //   if (this.minHeight) {
    //     style.minHeight = `${this.minHeight}px`;
    //   }
    //   if (this.height) {
    //     style.height = `${this.height}px`;
    //   }
    //   return style;
    // },
  },
  model: {
    prop: "desc",
    event: "change",
  },
  watch: {
    isClear(val) {
      // console.log(val)
      if (val) {
        this.editor.txt.clear();
      }
    },
    desc(value) {
      if (value != this.editor.txt.html()) {
        this.editor.txt.html(this.desc);
      }
    },
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.editor.destroy();
    this.editor = null;
  },
  methods: {
    getEditorData() {
      // 通过代码获取编辑器内容
      let data = this.editor.txt.html();
      alert(data);
    },

    init() {
      let that = this;
      let editor = new E("#wangEditorMain");
      editor.config.height = this.minHeight;
      editor.config.zIndex = 500;
      editor.config.uploadImgServer = this.getUploadUrl();
      editor.config.uploadImgMaxSize = 5 * 1024 * 1024; // 2M
      editor.config.uploadImgAccept = [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "bmp",
        "webp",
      ];
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadImgHeaders = {
        "access-token": this.commonJs.getCookie("ERPToken"),
      };
      editor.config.uploadImgParams = {
        // token: getToken(),
        resourceId: null,
        resourceType: "websiteInfoContentFile", //官网信息内容附件
      };
      editor.config.customAlert = function (s, t) {
        switch (t) {
          case "success":
            Message.success(s);
            break;
          case "info":
            Message.info(s);
            break;
          case "warning":
            Message.warning(s);
            break;
          case "error":
            Message.error(s);
            break;
          default:
            Message.info(s);
            break;
        }
      };
      editor.config.uploadFileName = "file";

      editor.config.uploadImgHooks = {
        // 上传图片之前
        before: function (xhr) {
          console.log(xhr);
          // 可阻止图片上传
          // return {
          //     prevent: true,
          //     msg: '需要提示给用户的错误信息'
          // }
          return true;
        },
        // 图片上传并返回了结果，图片插入已成功
        success: function (xhr) {
          console.log("success", xhr);
        },
        // 图片上传并返回了结果，但图片插入时出错了
        fail: function (xhr, editor, resData) {
          console.log("fail", resData);
          that.$message({
            type: "info",
            message: "图片上传错误",
          });
          return false;
        },
        // 上传图片出错，一般为 http 请求的错误
        error: function (xhr, editor, resData) {
          console.log("jinlai");
          console.log("error", xhr, resData);
        },
        // 上传图片超时
        timeout: function (xhr) {
          console.log("timeout");
        },
        // 图片上传并返回了结果，想要自己把图片插入到编辑器中
        // 例如服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
        customInsert: function (insertImgFn, result) {
          // result 即服务端返回的接口
          console.log("customInsert", result);
          // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
          // insertImgFn(that.showFileUrl(result.data.filePath));
          insertImgFn(that.showFileUrl(result.data[0].url));
        },
      };
      // 插入网络图片的回调
      editor.config.linkImgCallback = function (src, alt, href) {
        console.log("图片 src ", src);
        console.log("图片文字说明", alt);
        console.log("跳转链接", href);
        // return true
      };
      editor.config.menus = []; // 设置菜单
      editor.config.showFullScreen = false; // 全屏展示关闭
      // editor.config.excludeMenus = ["head", "table", "video", "todo", "code"]; //剔除少数菜单
      editor.config.onchange = (newHtml) => {
        this.editorData = newHtml; // 绑定当前逐渐地值
        this.$emit("change", this.editorData); // 将内容同步到父组件中
      };
      editor.create();
      editor.disable(); //禁止编辑
      this.editor = editor;
    },
    getUploadUrl() {
      return window.configPath.baseUrl + this.uploadFileUrl();
    },
    showFileUrl(path) {
      // return window.configPath.baseUrl + this.showFileUrlPart(path);
      return path;
    },
    // 上传文件地址
    uploadFileUrl() {
      return "/filem/richTextUpload";
    },

    showFileUrlPart(path) {
      return "/filem/view?id=" + photoId;
    },
  },
};
</script>

<style lang="scss" scoped>
#wangEditorMain {
  font-size: 18px;
}
.wangEditorMain {
  -webkit-user-select: text;
  ::v-deep .w-e-text-container {
    border: none !important;
  }
  ::v-deep .w-e-toolbar {
    border: none !important;
  }
  ::v-deep .w-e-content-mantle {
    min-height: 100%;
    height: unset;
    overflow-y: auto;
  }
  ::v-deep b {
    // font-weight: bolder !important;
    font-weight: bolder !important;
  }
  ::v-deep strong {
    font-weight: bolder !important;
  }
}
</style>
<style lang="scss">
.w-e-menu {
  z-index: 2 !important;
}
.w-e-text-container {
  z-index: 1 !important;
}
</style>